var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H8V10H6V22H4V10H2V2ZM10 19.7361V21C10 21.5523 10.4477 22 11 22C11.5523 22 12 21.5523 12 21V20.5H19V21C19 21.5523 19.4477 22 20 22C20.5523 22 21 21.5523 21 21V19.7361C21.6137 19.1868 22 18.3885 22 17.5V9.23607C22 8.11549 21.348 6.97653 20.1214 6.61791C19.1075 6.32149 17.5379 6 15.5 6C13.4621 6 11.8925 6.32149 10.8786 6.61791C9.65203 6.97653 9 8.11549 9 9.23607V17.5C9 18.3885 9.38625 19.1868 10 19.7361ZM20 10.75V13.25H11V10.75H20ZM13 17.5C13.5523 17.5 14 17.0523 14 16.5C14 15.9477 13.5523 15.5 13 15.5C12.4477 15.5 12 15.9477 12 16.5C12 17.0523 12.4477 17.5 13 17.5ZM19 16.5C19 17.0523 18.5523 17.5 18 17.5C17.4477 17.5 17 17.0523 17 16.5C17 15.9477 17.4477 15.5 18 15.5C18.5523 15.5 19 15.9477 19 16.5Z",
    fill: "#008C23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusstop);
export default __webpack_public_path__ + "static/media/Busstop.748770e668305035646ad31816a77a94.svg";
export { ForwardRef as ReactComponent };